import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { resolveImageUrl } from "../../../utils/imageUtils";

const renderSectionHeader = (section) => (
  <>
    {section?.title ? <h2>{section.title}</h2> : null}
    {section?.description ? <p className="dynamic-description">{section.description}</p> : null}
  </>
);

export const Section = ({ section, className, children, keyName }) => (
  <section key={keyName} className={`dynamic-section ${className || ""}`}>
    {renderSectionHeader(section)}
    {children}
  </section>
);

export const renderCtaButton = (button) => {
  if (!button?.label) return null;
  const el = <Button label={button.label} className="dynamic-cta-button" />;
  if (button.to) return <Link to={button.to}>{el}</Link>;
  if (button.href) return <a href={button.href} target="_blank" rel="noreferrer noopener">{el}</a>;
  return null;
};

const renderBoldText = (text = "") =>
  String(text).split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={`b-${i}`}>{part.slice(2, -2)}</strong>
      : <span key={`t-${i}`}>{part}</span>
  );

export const renderRichTextContent = (paragraphs = []) => {
  const blocks = [];
  for (let i = 0; i < paragraphs.length; i += 1) {
    const line = String(paragraphs[i] || "").trim();
    if (!line) continue;
    if (/^-\s+/.test(line)) {
      const items = [line.replace(/^-\s+/, "").trim()];
      let nextIndex = i + 1;
      while (nextIndex < paragraphs.length) {
        const nextLine = String(paragraphs[nextIndex] || "").trim();
        if (!/^-\s+/.test(nextLine)) break;
        items.push(nextLine.replace(/^-\s+/, "").trim());
        nextIndex += 1;
      }
      blocks.push(<ul key={`list-${i}`}>{items.map((item, idx) => <li key={`li-${i}-${idx}`}>{renderBoldText(item)}</li>)}</ul>);
      i = nextIndex - 1;
      continue;
    }
    blocks.push(<p key={`p-${i}`}>{renderBoldText(line)}</p>);
  }
  return blocks;
};

export const renderImage = (src, alt, className) =>
  src ? <Image src={resolveImageUrl(src)} alt={alt} className={className} /> : null;
